import { WindowSizeHelper } from "../helper/window-size-helper";
import { Logger } from "../logger/logger";
import { PanelToggleGroupVm } from "./panel-toggle-group-vm";

export interface IPanelInitializer {
	initialHeightPerc?: number;
	contentHeightCorrection?: number;
	useCustomAddLogic?: boolean;
	minimumHeightPrc?: number;
	maximumHeightPrc?: number;
}

export abstract class PanelVm {
	protected static readonly contentMinHeight = 40;
	protected static readonly contentMaxHeight = 100;
	protected static readonly contentStepHeight = 5;

	protected static readonly createTooltipItemTemplate = () => {
		return "<i class='dx-icon' data-bind='css: $data.icon'></i><span class='dx-menu-item-text' data-bind='text: $data.text, attr: {title: $data.tooltip}'></span><div class='dx-menu-item-popout-container' data-bind='visible: $data.items'><div class='dx-menu-item-popout'></div></div>";
	}

	private contentHeightValue: KnockoutObservable<number>;

	constructor(init?: IPanelInitializer) {
		init = init || {};

		let initialHeightPerc = init.initialHeightPerc;
		let contentHeightCorrection = init.contentHeightCorrection || 0;
		this.isCollapsed = ko.observable(false);
		this.contentHeightCorrection = ko.observable(contentHeightCorrection);
		this.contentHeightValue = ko.observable(initialHeightPerc).extend({ notify: "always" });

		this.contentHeight = ko.pureComputed({
			read: () => {
				return this.contentHeightValue();
			},
			write: (newHeight) => {
				this.isCollapsed(false);
				// due to display problems
				setTimeout(() => {
					this.contentHeightValue(newHeight);
				}, 0);
			}
		});

		this.contentHeightHigher = () => {
			let currentHeight = this.contentHeight() + PanelVm.contentStepHeight;
			this.contentHeight(currentHeight);
		};

		this.contentHeightLower = () => {
			let currentHeight = this.contentHeight() - PanelVm.contentStepHeight;
			if (currentHeight <= PanelVm.contentMinHeight) {
				currentHeight = PanelVm.contentMinHeight;
			}
			this.contentHeight(currentHeight);
		};

		this.contentToggleCollapse = () => {
			this.isCollapsed(!this.isCollapsed());
		};

		this.contentHeightAsPixel = ko.computed(() => {
			let curContentHeightValue = this.contentHeight();
			if (curContentHeightValue == null) {
				return null;
			}
			return WindowSizeHelper.calcSize(this.contentHeight()) - this.contentHeightCorrection();
		});

		this.contentHeightWithCorrectionAsPixel = ko.computed(() => {
			let curContentHeightValue = this.contentHeight();
			if (curContentHeightValue == null) {
				return null;
			}
			return WindowSizeHelper.calcSize(this.contentHeight());
		});

		this.contentHeightWithCorrectionAsPixelString = ko.computed(() => {
			return `${this.contentHeightWithCorrectionAsPixel()}px`;
		});

		this.contentHeightSliderOptions = {
			value: this.contentHeight,
			min: init.minimumHeightPrc || PanelVm.contentMinHeight,
			max: init.maximumHeightPrc || PanelVm.contentMaxHeight,
			step: PanelVm.contentStepHeight
		};
	}

	public contentHeight: KnockoutComputed<number>;
	public contentHeightAsPixel: KnockoutComputed<number>;
	public contentHeightWithCorrectionAsPixel: KnockoutComputed<number>;
	public contentHeightWithCorrectionAsPixelString: KnockoutComputed<string>;

	public isCollapsed: KnockoutObservable<boolean>;

	public contentHeightSliderOptions: any;

	public contentHeightLower: () => void;
	public contentHeightHigher: () => void;
	public contentToggleCollapse: () => void;

	public contentHeightCorrection: KnockoutObservable<number>;

	public toggleButtonClicked = (vm: any, event: JQuery.Event) => {
		// TODO (jpg) if collapse is getting out of sync, try find correct value via event parameter
		this.contentToggleCollapse();
	}
}